import { render, staticRenderFns } from "./searchBar.vue?vue&type=template&id=528cdb48&scoped=true"
import script from "./searchBar.vue?vue&type=script&lang=js"
export * from "./searchBar.vue?vue&type=script&lang=js"
import style0 from "./searchBar.vue?vue&type=style&index=0&id=528cdb48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528cdb48",
  null
  
)

export default component.exports